import classnames from "classnames";
import i18next from "i18next";
import * as React from "react";
import { useMapContext } from "../../Contexts/MapContext";
import "./ShrinkCoordsButton.scss";

export const ShrinkCoordsButton = (): JSX.Element => {
    const { coordsExpanded, setCoordsExpanded } = useMapContext();

    return (
        <div
            className={classnames("action-menu", "menu", "coords")}
            onClick={() => setCoordsExpanded(!coordsExpanded)}
            role="button"
            title={i18next.t("coordinates.extendCoordinates")}
        >
            <span className={classnames("esri-icon-left", { "esri-icon-right": coordsExpanded })} />
            &nbsp;X°,Y°
        </div>
    );
};
